import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { userThemeSelector } from "../../../../store/user/user.selectors";
import { setUserTheme } from "../../../../store/user/user.actions";

import SvgIcon from "../../../../components/ui-core/svg-icon";

import styles from "./styles.scss";
import { LEGACY_THEME_TYPES } from "../../../../components/styled/theme/ThemeProvider";

const ThemeSwitch = () => {
    const theme = useSelector(userThemeSelector);
    const dispatch = useDispatch();

    return (
        <div
            className={styles["login-theme-switch"]}
            onClick={() => {
                if (theme === LEGACY_THEME_TYPES.light) {
                    return dispatch(setUserTheme(LEGACY_THEME_TYPES.dark));
                }
                dispatch(setUserTheme(LEGACY_THEME_TYPES.light));
            }}
        >
            {theme === LEGACY_THEME_TYPES.dark && (
                <div className={styles[`login-theme-switch--sun`]}>
                    <SvgIcon type="switch-sun" />
                </div>
            )}
            {theme === LEGACY_THEME_TYPES.light && (
                <div className={styles[`login-theme-switch--moon`]}>
                    <SvgIcon type="switch-moon" />
                </div>
            )}
        </div>
    );
};

export default ThemeSwitch;
